<template>
  <div>
    <div class="modal-body p-0 pb-5 px-0" v-show="onload">
      <div class="content">
        <placeholder-content is-load="true" />
      </div>
    </div>
    <div v-show="!onload">
      <div v-show="!hasPermission" class="modal-body p-0 pb-5 px-0">
        <access-denied />
      </div>
      <div v-show="hasPermission">
        <div class="modal-body p-0 pb-5 px-0">
          <div class="px-0">
            <legend
              class="font-size-lg text-title-restocks-order mb-0 px-3 py-2"
              style="margin-bottom: 15px;"
            >
              <i class="fa-solid fa-circle-info text-title-restocks-order mr-1" />
              {{ $t("Order Information") }}
            </legend>
          </div>
          <p class="px-3 py-3 mb-0 text-title-restocks-order">
            <i class="fa-solid fa-box-taped mr-2"></i>
            {{ $t("Product Name") }}: {{ productName }}
          </p>
          <div class="content pt-0">
            <div :class="['datatable-scroll', loadingTable]">
              <!-- table-product -->
              <div class="card table-responsive mt-0 data-nowrap">
                <div :class="['vuetable-wrapper ui basic segment']">
                  <vuetable
                    :no-data-template="$t('No Data Available')"
                    class="dataTable thead-bg-fafafa table-hover"
                    ref="vuetable"
                    :data-manager="dataManager"
                    :api-mode="false"
                    :append-params="paramsQuery"
                    :fields="table.fields"
                    :css="{ sortableIcon: 'grey sort icon' }"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="vuetableLoaded"
                    @vuetable:loading="vuetableLoading"
                    data-path="data"
                    pagination-path=""
                    @vuetable:initialized="onInitialized"
                    :sort-order="table.sortOrder"
                  >
                  <div
                    slot="ch"
                    slot-scope="props"
                  >
                    <ChannelsLogoComponent
                      :product-id="props.rowData.id"
                      :channels-name="props.rowData.channel_name"
                      :channels-image-url="props.rowData.channel_logo"
                    />
                  </div>
                  <div
                      slot="channel_name"
                      slot-scope="props"
                    >
                      <div>
                        <a
                          class="text-dark pointer btn-link"
                          :href="'/app/orders/' + props.rowData.order_id"
                          target="_blank"
                          >
                            <ChannelsNameComponent
                              :channels-name="props.rowData.channel_name"
                            />
                          </a>

                      </div>
                    </div>
                    <div
                      slot="order_number"
                      slot-scope="props"
                    >
                      <router-link
                        target="_blank"
                        :to="{ name: 't.a.order.view', params: { id: props.rowData.order_id }}"
                      >
                        {{ props.rowData.order_number }}
                      </router-link>
                    </div>

                    <div
                      slot="customer_telephone1"
                      slot-scope="props"
                    >
                      <a
                        :href="'tel:' + props.rowData.customer_telephone1"
                        class="pointer btn-link"
                      >{{ props.rowData.customer_telephone1 }}</a>
                    </div>
                    <div
                      slot="carrier_channel_logo"
                      slot-scope="props"
                    >
                    <a
                      v-if="
                        props.rowData.carrier_channel_logo
                      "
                      v-tooltip:top="props.rowData.carrier_channel"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      class="text-dark"
                      href="javascript:void(0)"
                      data-toggle="modal"
                      data-target="#modal-shipment-detail"
                    >
                      <img
                        :src="props.rowData.carrier_channel_logo"
                        width="30"
                        class="image_box"
                      >
                    </a>
                    <a
                      v-else
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      class="text-dark"
                      href="javascript:void(0)"
                      data-toggle="modal"
                      data-target="#modal-shipment-detail"
                    >
                      <img
                        :src="$storeIndex.getImageSrc('no-carrier')"
                        width="30"
                        class="image_box"
                      >
                    </a>
                    </div>
                    <div
                      slot="payment_method_logo"
                      slot-scope="props"
                    >
                    <div v-if="props.rowData.sales_order">
                      <div
                        v-for="item in props.rowData.sales_order"
                        :key="item.order_id"
                      >
                        <a
                          href="javascript:void(0)"
                          v-if="item.payment_method == 'Bank Transfer'"
                          v-tooltip:top="$t(bankAccount(item.payments, 'name'))"
                          :data-original-title="$t(bankAccount(item.payments, 'name'))"
                        >
                          <img
                            :src="bankAccount(item.payments, 'logo')"
                            class="image_box"
                          >
                        </a>
                        <a
                          v-if="item.payment_method == 'COD'"
                          v-tooltip:top="$t('COD')"
                          :data-original-title="$t('COD')"
                        >
                          <img
                            :src="$storeIndex.getImageSrc('payment/cod', '.svg')"
                            class="image_box"
                          >
                        </a>
                        <a
                          v-if="item.payment_method != 'Bank Transfer' && item.payment_method != 'COD' && item.payment_method != 'Cash'"
                          v-tooltip:top="$t(item.payment_method)"
                          :data-original-title="$t(item.payment_method)"
                        >
                          <img
                            class="image_box rounded"
                            :src="$storeIndex.paymentLogo(item.payment_method_logo)"
                          >
                        </a>

                      </div>

                    </div>
                      <div v-else>
                        <a
                          v-tooltip:top="$t('COD')"
                          :data-original-title="$t('COD')"
                        >
                          <img
                            :src="$storeIndex.getImageSrc('payment/cod', '.svg')"
                            class="image_box"
                          >
                        </a>
                      </div>
                    </div>


                    <div
                      slot="tracking_code"
                      slot-scope="props"
                    >
                      <div
                        class="item-name"
                        style="width: calc(100% - 35px)"
                      >
                        <span
                          class="pointer btn-link"
                          @click="sendTrackingGoship(props.rowData.tracking_code)"
                        >
                          {{ props.rowData.tracking_code }}
                        </span>
                      </div>
                    </div>

                    <div slot="action" slot-scope="props">
                      <div class="list-icons">
                        <div class="dropdown">
                          <a
                            href="#"
                            class="list-icons-item"
                            data-toggle="dropdown"
                          >
                            <i class="icon-menu9" />
                          </a>
                          <div
                            class="dropdown-menu dropdown-sale-order dropdown-menu-right"
                          >
                            <!-- Action List -->

                            <!-- View Order -->
                            <a
                              :href="'/app/orders/' + props.rowData.id"
                              target="_blank"
                              class="dropdown-item"
                              ><i class="fa-1x fa-solid fa-eye" />{{
                                $t("View")
                              }}
                            </a>
                            <a href="javascript:void(0)" class="dropdown-item">
                              <i class="fa-solid fa-plus-minus fa-1x mr-2"></i>
                              {{ $t("Create Quantity Adjustment") }}
                            </a>
                            <!-- <a
                              href="javascript:void(0)"
                              class="dropdown-item"
                              @click="$parent.ignoreItem()"
                            >
                              <i class="fa-solid fa-circle-x mr-2"></i>
                              {{ $t("Ignore") }}
                            </a> -->

                            <!-- Action List End -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </vuetable>
                </div>
              </div>
            </div>
            <!-- table-product -->
          </div>
        </div>

        <div class="card-footer fixed-bottom bg-light d-flex justify-content-between">
          <div>
            <button
              @click="previous()"
              type="button"
              class="btn btn-light text-left"
            >
              <i class="fas fa-arrow-circle-left mr-2"></i>
              {{ $t("Previous") }}
            </button>
          </div>
          <div class="btn-group ml-xl-n5">
            <button
              type="button"
              class="btn btn-primary dropdown-toggle mr-2"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa-solid fa-ellipsis fa-1x mr-1" />
              {{ $t("More Action") }}
            </button>

            <div
              class="dropdown-menu dropright dropdown-restock-bulk-action"
            >
              <a
                href="javascript:void(0)"
                class="dropdown-item"
                @click="$parent.validateRestock([ordertData])"
              >
                <i class="fa-solid fa-plus-minus mr-2" />
                {{ $t("Create Quantity Adjustment") }}
              </a>

              <!-- <a
                href="javascript:void(0)"
                class="dropdown-item"
                @click="ignoreItem($parent.ignoreSelected)"
              >
                <i class="fa-solid fa-circle-x mr-2"></i>
                {{ $t("Ignore") }}
              </a> -->
            </div>
            <button type="button" class="btn btn-light" @click="$parent.closeModal()">{{$t('Cancel')}}</button>
          </div>

          <div></div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service";
import FieldsDef from "../assets/FieldsRestockOrder";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";
import Vuetable from "vuetable-2";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import ChannelsLogoComponent from '@/components/tenancy/center/ChannelsLogoComponent.vue';
import ChannelsNameComponent from '@/components/tenancy/center/ChannelsNameComponent.vue';

export default {
  name: "modalRestock",
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PlaceholderContent,
    AccessDenied,
    ChannelsLogoComponent,
    ChannelsNameComponent
  },
  props: {
    ordertData: {
      type: [Array, Object],
      default: () => {
        return {};
      },
    },
    productName: {
      type: [String],
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      onload: true,
      loading: "",
      loadingTable: "",
      hasPermission: false,
      filter: {
        limit: 10,
        page: 1,
        viewpoint: "all"
      },
      table: {
        fields: FieldsDef,
        sortOrder: [
          // {
          //   field: "balance",
          //   direction: "desc",
          // },
        ]
      },
      paramsQuery: {
        limit: 10,
        page: 1,
        viewpoint: "all"
      }
    };
  },
  watch: {},
  mounted() {
    // this.showModal();
  },
  methods: {
    async setParams(filter, page = 0) {
      this.loadingTable = "loading";
      let self = this;
      // let data = self.$storeIndex.mutations.vueTableFormatJson(getList);
      self.$refs.vuetable.setData(this.ordertData.sales_order);
      this.onload = false;
      this.hasPermission = true;
      this.loadingTable = "";
    },
    dataManager(sortOrder, pagination) {
      if (sortOrder.length > 0) {
        this.filter.sort = sortOrder
          .map(item => `${item.sortField}|${item.direction}`)
          .join(",");
      }
      this.setParams(this.filter);
    },
    setPerPage(perPage) {
      this.paramsQuery.page = 1;
      this.$refs.vuetable.currentPage = 1;
      this.filter.limit = perPage;
      this.setParams(this.filter);
    },

    onChangePage(page) {
      this.paramsQuery.page = page;
      this.$refs.vuetable.changePage(page);
    },
    vuetableLoaded() {
      this.loading = "";
    },
    vuetableLoading() {
      this.loading = "loading";
    },
    onPaginationData(tablePagination) {
      this.$refs.pagination.setPaginationData(tablePagination);
      this.$refs.paginationInfo.setPaginationData(tablePagination);
    },
    onInitialized(fields) {
      this.vuetableFields = fields.filter(field => field.togglable);
    },
    previousModal() {
      this.$parent.showRestockOrder = false;
    },
    AdjustmentModal: async function (product_id) {
      $("#ModalRestock").modal("hide");
      this.$parent.$parent.isRestockModal = false;
      this.$parent.$parent.isAdjustmentModal = true;
      await this.$nextTick();
      $("#ModalRestock").modal("toggle");
      $("#action_modal").modal("toggle");

    },
    sendTrackingGoship(trackingCode) {
      window.open(
        process.env.GOSHIP_URL + "/c/?track=" + trackingCode,
        "_blank"
      );
    },
    bankAccount: function(payments, type) {
      let stampReturn = 0;
      let image = this.$storeIndex.getImageSrc("bank/none");
      let name = "Bank Transfer";
      if (payments.length > 0) {
        payments.map(function(item) {
          if (item.status != "canceled" && item.bank_account_logo != "" && stampReturn == 0) {
            image = item.bank_account_logo;
            name = item.bank_account_name;
            stampReturn++;
          }
        });
      }
      return type == "logo" ? image : type == "name" ? name : "";
    },
    ignoreItem(items) {
      let obj = {
        product_ids: [...new Set(items.product_ids)],
        order_ids: [...new Set(items.order_ids)]
      };
      let self = this;
      this.$swal.fire({
        title: this.$t("Ignore Quantity Adjustment") + " ?",
        iconHtml:
          '<i class="fa-light fa-circle-exclamation" style="font-weight:300; font-size:6rem;"></i>',
        iconColor: "#FF7043",
        html: `<div class="row mr-2 ml-2">
              <div class="col-12 bbbb-soft-pink">
                ${this.$t(
                  "Will be remove from product adjustment. You cannot undo this process."
                )}
              </div>
            </div>`,
        showCancelButton: true,
        reverseButtons: false,
        confirmButtonText:
          '<i class="fa-solid fa-check-circle mr-2"></i>' + this.$t("Confirm"),
        cancelButtonText: this.$t("Cancel"),
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-light",
          loader: "custom-loader"
        },
        loaderHtml: '<div class="spinner-border text-primary"></div>',
        focusConfirm: false,
        showLoaderOnConfirm: true,
        preConfirm: async function() {
          return await Api.Inventory.ignoreProducts(obj)
            .then(response => {
              if (response.status == 200) {
                self.$toastr.s(
                  self.$t("Ignore Quantity Adjustment Success."),
                  "<span class='fa-solid fa-circle-check mr-2'></span>" +
                    self.$t("Success")
                );
                self.previous();
                self.$parent.setParams();
                self.$store.dispatch("inventory/refreshAlertRestock", true);
              }
            })
            .catch(e => {
              switch (e.response.status) {
                case 403:
                  self.$swal({
                    icon: false,
                    iconColor: "#FF7043",
                    title: self.$t("Access Denied"),
                    html:
                      self.$t("You do not have permission to access this page.") +
                      "<br/>" +
                      self.$t(
                        "If you feel this is a mistake, contact your admin."
                      ),
                    showCancelButton: false,
                    confirmButtonText:
                      '<i class="fa-solid fa-thumbs-up mr-1"></i> ' +
                      self.$t("OK"),

                    imageUrl: require("@/assets/images/activities/icon-access-denied.png"),
                    buttonsStyling: false,
                    customClass: {
                      confirmButton: "btn btn-primary mr-2",
                      cancelButton: "btn btn-light"
                    },
                    focusConfirm: false,
                    showLoaderOnConfirm: true,
                    popup: "validation-access-denied"
                  });
                break;

                case 400:
                  self.$toastr.e(
                    self.$t("Ignore Quantity Adjustment Failed."),
                    "<span class='icon-blocked'></span>" + self.$t("Error")
                  );
                break;

                default:
                self.$toastr.e(
                  self.$t("Something went wrong. Please try again."),
                  "<span class='icon-blocked'></span>" + self.$t("Error")
                );
                break;
              }
            });
        }
      });
    },
    previous() {
      this.$parent.showRestockOrder = false
      this.$parent.isRestockModal = true;
    },
  }
};
</script>

<style scope>
.vuetable-body-wrapper {
  border-top: 0px solid #dddddd;
}
.dropdown-menu.dropdown-sale-order.dropdown-menu-right.show {
  width: 210px;
}
.text-title-restocks-order {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/restock/RestockOrder.vue